module.exports = __webpack_public_path__ + "static/six-easy-pieces-34d63a913fc7d5a14aad72e3bfef7818.jpg";